var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconButtonLista(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94444 9.72214H25V8.33325H6.94444V9.72214Z",
    fill: "#727E8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94444 1.38889H25V0H6.94444V1.38889Z",
    fill: "#727E8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94444 18.0556H25V16.6667H6.94444V18.0556Z",
    fill: "#727E8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.72214H2.77778V8.33325H0V9.72214Z",
    fill: "#727E8C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.38889H2.77778V0H0V1.38889Z",
    fill: "#727E8C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.0556H2.77778V16.6667H0V18.0556Z",
    fill: "#727E8C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconButtonLista);
export default __webpack_public_path__ + "static/media/icon_button_lista.b4e3c04d.svg";
export { ForwardRef as ReactComponent };